import { useTranslation } from 'react-i18next';
// material
import { enUS, deDE, frFR, zhCN, zhHK } from '@mui/material/locale';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: '中文繁體',
    value: 'zh',
    systemValue: zhHK,
    icon: '/static/icons/ic_flag_cn.svg'
  },
  {
    label: '中文简体',
    value: 'cn',
    systemValue: zhCN,
    icon: '/static/icons/ic_flag_cn.svg'
  },
  {
    label: 'English',
    value: 'english',
    systemValue: enUS,
    icon: '/static/icons/ic_flag_en.svg'
  },
  {
    label: 'German',
    value: 'de',
    systemValue: deDE,

    icon: '/static/icons/ic_flag_de.svg'
  },
  {
    label: 'French',
    value: 'fr',
    systemValue: frFR,
    icon: '/static/icons/ic_flag_fr.svg'
  }
];

export default function useLocales() {
  const { i18n, t: trans } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0];

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    trans,
    currentLang,
    allLang: LANGS
  };
}
